<section *ngIf="isLoading">
  <img src="/assets/img/loader.svg" alt="Cargando..." />
</section>
